import { FinalImpactScoreType } from '@upright/common/model/output/scores/types';
import { aggregateResultAreaLayout } from '@upright/ui/common/upright/core/impact-lenses/net-impact/aggregate-result/layout';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { AggregateMetricProps } from '@upright/ui/common/upright/model/output/scores/aggregate-metrics';
import { getValueSetName } from '@upright/ui/untidy/redux/selectors';
import { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import { ImpactRankInfo } from './impact-rank-info';
import { useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { ImpactSummaryTextWithIcon } from './impact-summary-text-with-icon';

export function ImpactSummaryAndRankArea(
  props: { scoreUnit: FinalImpactScoreType | undefined } & AggregateMetricProps,
) {
  const context = useNetImpactLensContext();
  const valueSet = useSelector(getValueSetName);
  const layout = aggregateResultAreaLayout(useCarouselLayout(), valueSet);
  const area = layout.impactSummaryAndRankBounds();

  function getStyle() {
    const common: CSSProperties = {
      zIndex: 1,
      top: area.y1,
      left: area.x1,
      width: area.width,
      height: area.height,
      position: 'absolute',
      display: 'flex',
      gap: 16,
      paddingLeft: area.narrowMode ? 10 : 20,
    };

    if (area.narrowMode) {
      const style: CSSProperties = {
        ...common,
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
      };
      return style;
    } else {
      const style: CSSProperties = {
        ...common,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
      };
      return style;
    }
  }

  if (!context) {
    return <></>;
  }
  return (
    <div style={getStyle()}>
      <ImpactSummaryTextWithIcon currentMetric={props.currentMetric} entityType={context.data?.entity?.type} />
      <ImpactRankInfo entityType={context.data?.entity?.type} />
    </div>
  );
}
